import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getSmsCount } from 'src/reducers/campaignEditor';

const SmsValidity = ({ smsCount }) => {
  const { t } = useTranslation();
  return (
    <Typography
      color="textSecondary"
      style={{ margin: '5px 10px', overflow: 'visible' }}
      variant="body1"
      noWrap
    >
      {`${t('smartmessaging.contentEditor.sms.content.messageLength')} : `}
      {(smsCount && smsCount.length) || 0}
      <br />
      {`${t('smartmessaging.contentEditor.sms.content.numberOfSms')}:${smsCount.numOfPart || 1}`}
      <br />
      {`${t('smartmessaging.contentEditor.sms.content.invalidChars')} : ${smsCount &&
        smsCount.invalidChar &&
        smsCount.invalidChar.length &&
        smsCount.invalidChar}` || 0}
    </Typography>
  );
};

SmsValidity.propTypes = {
  smsCount: PropTypes.any.isRequired,
};

SmsValidity.defaultProps = {};

const mapStateToProps = state => ({
  smsCount: getSmsCount(state),
});

export default connect(mapStateToProps)(SmsValidity);
